import { Box, Stack, Typography } from "@mui/material";
import { SalarySacrifice } from "../../../models/salarySacrifices/salarySacrifice";
import { formatCurrency, formatDate } from "../../../utils/formatters";
import { toTitleCase } from "../../../utils/toTitleCase";
import { SideDrawer } from "../../shared/SideDrawer/SideDrawer";

interface SalarySacrificeInfoDrawerProps {
  salarySacrifice: SalarySacrifice | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const SalarySacrificeInfoDrawer: React.FC<
SalarySacrificeInfoDrawerProps
> = ({ salarySacrifice, isOpen, setIsOpen }) => {
  return (
    <SideDrawer
      title="Contribution Details"
      open={isOpen}
      setIsOpen={setIsOpen}
    >
      <Stack spacing={3} mx={2}>
        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Date
          </Typography>
          <Typography variant="body1">
            {salarySacrifice?.createdAt
              ? formatDate(salarySacrifice.createdAt)
              : "-"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Amount
          </Typography>
          <Typography variant="body1">
            {salarySacrifice?.amount
              ? formatCurrency(salarySacrifice.amount.amount)
              : "-"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Status
          </Typography>
          <Typography variant="body1">
            {salarySacrifice?.status
              ? toTitleCase(salarySacrifice.status)
              : "-"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Account ID
          </Typography>
          <Typography variant="body1">
            {salarySacrifice?.code || "-"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="black" fontWeight="bold">
            Employee ID
          </Typography>
          <Typography variant="body1">
            {salarySacrifice?.reference || "-"}
          </Typography>
        </Box>

        {salarySacrifice?.assignmentMetadata && (
          <>
            <Box>
              <Typography variant="subtitle2" color="black" fontWeight="bold">
                Account Name
              </Typography>
              <Typography variant="body1">
                {salarySacrifice.assignmentMetadata.planName || "-"}
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="black" fontWeight="bold">
                Employee Name
              </Typography>
              <Typography variant="body1">
                {salarySacrifice.assignmentMetadata.employeeFullName || "-"}
              </Typography>
            </Box>
          </>
        )}
      </Stack>
    </SideDrawer>
  );
};
